// admins-dashboard.component.ts
import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';
import { range, Subject } from 'rxjs';
import { CountUpPipe } from '../shared/pipes/count-up.pipe';
import { ChartConfiguration } from 'chart.js';
import { NgChartsModule } from 'ng2-charts';
import { FlowStatuses, Roles } from '../../models/commonmodel';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { AdminsRestService } from '../../services/admins-rest.service';
import { InitialsPipe } from "../shared/pipes/intials.pipe";
import { FormsModule } from '@angular/forms';
import { NewAgent } from '../../models/modeladmins';
import { LoaderComponent } from "../shared/loader/loader.component";
import { NoDataFoundComponent } from "../shared/no-data-found/no-data-found.component";
import {TimeAgoPipe} from "../shared/pipes/time-ago.pipe";
interface Agent {
  id: string;
  name: string;
  status: 'active' | 'inactive' | 'pending';
  color: string;
  // flexible so role-specific keys like 'sent_pending' are allowed
  data: Record<string, number>;
}

interface ChartData {
  label: string;
  value: number;
  color: string;
}

interface Activity {
  id: string;
  type: 'processed' | 'requested' | 'submitted' | 'open';
  text: string;
  time: string;
}

@Component({
  selector: 'app-admins-dashboard',
  standalone: true,
  imports: [CommonModule, CountUpPipe, NgChartsModule, InitialsPipe, FormsModule, LoaderComponent, NoDataFoundComponent,TimeAgoPipe],
  templateUrl: './admins-dashboard.component.html',
  styleUrls: ['./admins-dashboard.component.scss'],
  animations: [
    trigger('chartTransition', [
      transition('* => *', [
        style({ opacity: 0, transform: 'scale(0.8)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ])
    ])
  ]
})
export class AdminsDashboardComponent implements OnInit {
  // reactive state
  agents: Agent[] = [];
  selectedAgent: any;
  isSidebarCollapsed = false;
  showAll: boolean = true;
  // timeRange kept for UI control (currently uses static role-based data)
  timeRange: 'weekly' | 'monthly' | 'yearly' = 'weekly';
  isAgentDropdownOpen = false;
  private lastToggleAtMs = 0;
  useHeaderAgentSelector = true;
  isSidebarExpanded: boolean = false;
  enumRole = Roles;
  agentSearchText: string = '';
  agentList: NewAgent[] = [];
  colors = ['#0075C9', '#66AEE0'];
  userRole = this.memberService.getLoginUserRole() || '';
  cardConfigs: Array<{ key: string; label: string; icon: string; bg: string; iconBg: string; hoverTrigger$: Subject<void> }> = [];
recentActivityLoading:boolean=false;

  mockActivities: Activity[] = [
    { id: '1', type: 'processed', text: 'John Smith completed 5 new applications', time: '2 minutes ago' },
    { id: '2', type: 'submitted', text: 'Sarah Johnson submitted medical evidence for case #1234', time: '15 minutes ago' },
    { id: '3', type: 'requested', text: 'Mike Wilson requested additional documents', time: '1 hour ago' },
    { id: '4', type: 'open', text: 'New case assigned to Emily Davis', time: '2 hours ago' },
    { id: '5', type: 'processed', text: 'John Smith processed 3 insurance claims', time: '3 hours ago' },
    { id: '6', type: 'submitted', text: 'David Brown submitted case review for #5678', time: '4 hours ago' },
    { id: '7', type: 'requested', text: 'Lisa Anderson requested client interview', time: '5 hours ago' },
    { id: '8', type: 'open', text: 'High priority case escalated to supervisor', time: '6 hours ago' }
  ];

  getColor(index: number): string {
    return this.colors[index % this.colors.length];
  }

  // Chart bindings
  lineChartData: ChartConfiguration<'line'>['data'] = {
    labels: [],
    datasets: []
  };

  lineChartOptions: ChartConfiguration<'line'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: true },
      tooltip: {
        enabled: true,
        backgroundColor: '#ffffff', // white background
        titleColor: '#000000',      // title text color (black)
        bodyColor: '#000000',       // body text color (black)
        borderColor: '#000000',     // optional: black border
        borderWidth: 1
      }
    },
    elements: {
      line: { tension: 0.4 },
      point: { radius: 4 }
    },
    scales: {
      y: {
        grid: { display: false },
        beginAtZero: true
      },
      x: {
        grid: { display: false },
        ticks: {
          maxRotation: 0,
          minRotation: 0,
          autoSkip: false,
          callback: function (value, index, ticks) {
            const label = this.getLabelForValue(Number(value));
            return label.length > 15 ? label.substr(0, 15) + '…' : label;
          },
          font: { size: 12 }
        }
      }
    }
  };


  constructor(private memberService: MemberInsurerServiceService, private restService: AdminsRestService) { }

  ngOnInit(): void {
    this.memberService.sidebarExpanded$.subscribe((expanded) => {
      if (expanded) {
        this.isSidebarExpanded = false;
      } else {
        this.isSidebarExpanded = true;
      }
    });

    this.getAgents();
    this.configureCardsForRole(this.userRole);
    this.getStatusCounts();
    this.getProgressonAgentandCycle();
    this.getRecentActivities();
  }

  recentActivity: any[] = [];
  getRecentActivities() {
    this.recentActivityLoading = true;
    this.recentActivity = [];
    this.restService.getRecentActivities(this.selectedAgent?.userId).subscribe({
      next: (res) => {
        this.recentActivity = res.activities || [];
        this.recentActivityLoading = false;
      },
      error: () => {
        this.recentActivity = [];
        this.recentActivityLoading = false;
      }
    });
  }

  getAgents() {
    this.agentList = [];
    this.restService.getAgentsByOrgandRole().subscribe({
      next: (res: NewAgent[]) => {
        this.agentList = res || [];
        console.log("admin list", this.agentList);
      },
      error: () => {
        this.agentList = [];
      }
    });
  }

  graphData: Record<string, number> = {};
  getProgressonAgentandCycle() {
    this.graphData = {};
    this.restService.getProgressonAgentandCycle(this.selectedAgent?.userId, this.timeRange).subscribe({
      next: (res) => {
        this.graphData = res.data || {};
        this.updateChart();
      },
      error: () => {
        this.graphData = {};
        this.updateChart();
      }
    });
  }

  // Role-based card configuration (unchanged)
  configureCardsForRole(role: any): void {
    if (role === this.enumRole.INSURER) {
      this.cardConfigs = [
        { key: FlowStatuses.PENDING_REQUESTS, label: 'Sent/Pending Requests', icon: 'send', bg: '#D1FAE5', iconBg: '#10B981', hoverTrigger$: new Subject<void>() },
        { key: FlowStatuses.MORE_INFO_REQUESTED, label: 'More Info Requested', icon: 'info', bg: '#DBEAFE', iconBg: '#3B82F6', hoverTrigger$: new Subject<void>() },
        { key: FlowStatuses.MEDICAL_EVIDENCE_RECEIVED, label: 'Medical Evidence Received', icon: 'inbox', bg: '#FDE68A', iconBg: '#F59E0B', hoverTrigger$: new Subject<void>() },
        { key: FlowStatuses.TOTAL_EVIDENCE_REQUESTS, label: 'Total Evidence Requests', icon: 'pie', bg: '#FECACA', iconBg: '#EF4444', hoverTrigger$: new Subject<void>() }
      ];
    } else if (role === this.enumRole.PROVIDER) {
      this.cardConfigs = [
        { key: FlowStatuses.OPEN, label: 'Open Requests', icon: 'clock', bg: '#DBEAFE', iconBg: '#3B82F6', hoverTrigger$: new Subject<void>() },
        { key: FlowStatuses.IN_PROGRESS, label: 'In Progress', icon: 'spinner', bg: '#FDE68A', iconBg: '#F59E0B', hoverTrigger$: new Subject<void>() },
        { key: FlowStatuses.MORE_INFO_REQUESTED, label: 'More Info Requested', icon: 'info', bg: '#E0E7FF', iconBg: '#6366F1', hoverTrigger$: new Subject<void>() },
        { key: FlowStatuses.COMPLETED, label: 'Completed Requests', icon: 'check', bg: '#D1FAE5', iconBg: '#10B981', hoverTrigger$: new Subject<void>() }
      ];
    } else {
      // Distributor
      this.cardConfigs = [
        { key: FlowStatuses.DRAFTED, label: 'Draft (Awaiting Submission)', icon: 'document', bg: '#E0E7FF', iconBg: '#6366F1', hoverTrigger$: new Subject<void>() },
        { key: FlowStatuses.SUBMITTED_AWAITING_INSURER, label: 'Submitted (Awaiting Insurer)', icon: 'send', bg: '#DBEAFE', iconBg: '#3B82F6', hoverTrigger$: new Subject<void>() },
        { key: FlowStatuses.SUBMITTED_AWAITING_ACCEPTANCE, label: 'Submitted (Awaiting Acceptance)', icon: 'clock', bg: '#FDE68A', iconBg: '#F59E0B', hoverTrigger$: new Subject<void>() },
        { key: FlowStatuses.DECLINED_BY_INSURER, label: 'Declined by Insurer', icon: 'x', bg: '#FECACA', iconBg: '#EF4444', hoverTrigger$: new Subject<void>() }
      ];
    }
  }

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  setTimeRange(range: 'weekly' | 'monthly' | 'yearly'): void {
    this.timeRange = range;
    this.getProgressonAgentandCycle();
  }

  // Build chart-friendly array (used by donut/pie if needed)
  getChartData(): ChartData[] {
    const data = this.selectedAgent?.data ?? this.getConsolidatedData();
    // If cardConfigs are role-specific, prefer them; otherwise fallback to default keys
    const keys = this.cardConfigs.length ? this.cardConfigs.map(c => c.key) : ['processed', 'requested', 'submitted', 'open'];

    return keys.map((k, idx) => ({
      label: this.cardConfigs[idx]?.label ?? k,
      value: data[k] ?? 0,
      color: this.cardConfigs[idx]?.iconBg ?? ['#10B981', '#F59E0B', '#3B82F6', '#EF4444'][idx % 4]
    }));
  }

  getTotalValue(): number {
    return this.getChartData().reduce((s, it) => s + it.value, 0);
  }

  // If you request status counts by one of the known core keys, use this
  getStatusCount(status: string): number {
    if (this.selectedAgent) {
      return this.selectedAgent.data[status] ?? 0;
    }
    return this.getConsolidatedData()[status] ?? 0;
  }

  // Consolidated data (fallback for the four core keys so other functions that expect them still work)
  private getConsolidatedData(): Record<string, number> {
    const consolidated: Record<string, number> = {};

    // initialize all keys to 0 (take from first agent as reference)
    if (this.agents.length > 0) {
      Object.keys(this.agents[0].data).forEach(key => {
        consolidated[key] = 0;
      });
    }

    // sum values across all agents
    this.agents.forEach(agent => {
      Object.entries(agent.data).forEach(([key, value]) => {
        consolidated[key] += value ?? 0;
      });
    });

    return consolidated;
  }


  // Main updateChart - uses cardConfigs dynamically
  updateChart() {
    // Ensure cardConfigs is set for the current role
    if (!this.cardConfigs || this.cardConfigs.length === 0) {
      // fallback: use all keys from graphData if available
      if (this.graphData && typeof this.graphData === 'object') {
        this.cardConfigs = Object.keys(this.graphData).map((key, idx) => ({
          key,
          label: key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
          icon: 'info',
          bg: '#DBEAFE',
          iconBg: '#3B82F6',
          hoverTrigger$: new Subject<void>()
        }));
      } else {
        this.cardConfigs = [];
      }
    }

    // Prepare chart labels and data from cardConfigs and graphData
    const labels = this.cardConfigs.map(cfg => cfg.label);
    const data = this.cardConfigs.map(cfg => this.graphData?.[cfg.key] ?? 0);

    // Choose color based on role or fallback
    const borderColor = '#3b82f6';
    const backgroundColor = 'rgba(59,130,246,0.2)';

    this.lineChartData = {
      labels,
      datasets: [
        {
          label: 'Status',
          data,
          borderColor,
          backgroundColor,
          fill: true
        }
      ]
    };
  }

  getCardCount(cardKey: string): number {
    return this.statusCounts?.[cardKey] ?? 0;
  }

  // Utility methods for dashboard metrics
  getAgentPerformanceSummary(): { total: number; average: number; topPerformer: string } {
    if (this.agents.length === 0) {
      return { total: 0, average: 0, topPerformer: 'N/A' };
    }

    const totalProcessed = this.agents.reduce((sum, agent) => sum + (agent.data['processed'] ?? 0), 0);
    const average = Math.round(totalProcessed / this.agents.length);

    const top = this.agents.reduce((topSoFar, curr) =>
      (curr.data['processed'] ?? 0) > (topSoFar.data['processed'] ?? 0) ? curr : topSoFar
      , this.agents[0]);

    return {
      total: totalProcessed,
      average,
      topPerformer: top?.name ?? 'N/A'
    };
  }

  getStatusPercentage(status: string): number {
    const data = this.selectedAgent?.data ?? this.getConsolidatedData();
    // const total = Object.values(data).reduce((s, v) => s + (v ?? 0), 0);
    // return total > 0 ? Math.round(((data[status] ?? 0) / total) * 100) : 0;
    return 0;
  }

  isAgentActive(agent: Agent): boolean {
    return agent.status === 'active';
  }

  getAgentEfficiency(agent: Agent): number {
    const total = Object.values(agent.data).reduce((s, v) => s + (v ?? 0), 0);
    return total > 0 ? Math.round(((agent.data['processed'] ?? 0) / total) * 100) : 0;
  }

  getAgentActiveLabel(agent: NewAgent): string {
    return agent.isactive ? 'Active' : 'Deactivated';
  }

  getAgentActiveClass(agent: NewAgent): 'active' | 'deactivated' {
    return agent.isactive ? 'active' : 'deactivated';
  }

  // Agent dropdown & selection helpers
  toggleAgentDropdown(): void {
    this.isAgentDropdownOpen = !this.isAgentDropdownOpen;
    this.lastToggleAtMs = Date.now();
  }

  selectAgentFromDropdown(agent: NewAgent | null): void {
    this.selectedAgent = agent;
    this.showAll = !agent;
    this.isAgentDropdownOpen = false;

    this.getStatusCounts();
    this.getProgressonAgentandCycle();
    this.getRecentActivities();
    // this.updateChart();
  }

  statusCounts: Record<string, number> = {};

  getStatusCounts() {
    this.restService.getStatusCounts(this.selectedAgent?.id).subscribe({
      next: (res) => {
        if (res) {
          this.statusCounts = res;
        }
      },
      error: () => {
        this.statusCounts = {}; // ✅ must stay an object
      }
    });
  }


  getSelectedAgentColor(): string {
    return this.selectedAgent?.color ?? '#0075C9';
  }

  getSelectedAgentName(): string {
    return this.selectedAgent
      ? `${this.selectedAgent.firstName} ${this.selectedAgent.lastName}`
      : 'All Agents';
  }


  trackByAgentId(index: number, admin: NewAgent): string {
    return admin.id;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    // small debounce to avoid immediate re-close after toggle
    if (Date.now() - this.lastToggleAtMs < 50) {
      return;
    }
    const target = event.target as Element | null;
    if (!target) {
      this.isAgentDropdownOpen = false;
      return;
    }
    const dropdownRoot = (target as Element).closest('.agent-dropdown');
    if (!dropdownRoot) {
      this.isAgentDropdownOpen = false;
    }
  }

  getFilteredAdmins(): any[] {
    if (!this.agentList) return [];
    if (!this.agentSearchText) return this.agentList;
    const search = this.agentSearchText.toLowerCase();
    return this.agentList.filter(agent =>
      `${agent.firstName} ${agent.lastName}`.toLowerCase().includes(search)
    );
  }
}
